import UpdatePurchaseInvoice from "../../../../components/@documents/purchase_invoices/UpdatePurchaseInvoice";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function PurchaseInvoiceUpdatePage() {

    return (
        <UpdatePurchaseInvoice 
            routeType={routeTypes.retail}
        />
    )
}